import { useState, useEffect } from 'react';

import { breakpoints } from 'utils/breakpoints';

export const useWindowSize = () => {
  const isClient = typeof window === 'object';

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined,
      isLG: isClient ? window.innerWidth < breakpoints.lg : undefined,
      isLGBG: isClient ? window.innerWidth >= breakpoints.lg_bg : undefined,
      isMD: isClient ? window.innerWidth < breakpoints.md : undefined,
      isMDPR: isClient ? window.innerWidth < breakpoints.md_pr : undefined,
      isSM: isClient ? window.innerWidth < breakpoints.sm : undefined,
      isXL: isClient ? window.innerWidth < breakpoints.xl : undefined,
      isXXL: isClient ? window.innerWidth < breakpoints.xxl : undefined,
      isXS: isClient ? window.innerWidth < breakpoints.xs : undefined,
      isSMMD: isClient ? window.innerWidth < breakpoints.sm_md : undefined,
      isMDSM: isClient ? window.innerWidth < breakpoints.md_sm : undefined,
    };
  }

  const [windowSize, setWindowSize] = useState(getSize);

  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  useEffect(() => {
    if (!isClient) {
      return false;
    }

    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return windowSize;
};
